'use client'

import dynamic from 'next/dynamic'

const SaleProductsSection = dynamic(() => import('./SaleProductsSection'), { ssr: false })

const CategorySale = ({ category, saleCategories }) => {
    return (
        <SaleProductsSection
            category={category}
            saleCategories={saleCategories || []}
        />
    )
}

export default CategorySale
